var map = {
	"./MyPost/components/Consignments.vue": [
		68739,
		739
	],
	"./ParcelContract/components/Consignments.vue": [
		47308,
		308
	],
	"./eParcel/components/Consignments.vue": [
		32072,
		72
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 2028;
module.exports = webpackAsyncContext;